"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.validationSchema = (0, yup_1.object)().shape({
    contractId: yup_rules_1.dbIdValidationSchema,
    address: yup_rules_eth_1.addressValidationSchema,
    ticket: mui_inputs_asset_1.templateAssetValidationSchema,
    price: mui_inputs_asset_1.templateAssetValidationSchema,
    maxTicket: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map